import { Play, AlertTriangle } from 'lucide-react'

type Props = { props: Record<string, string | number | boolean> }

const ALLOWED_VIDEO_DOMAINS = ['youtube.com', 'youtu.be', 'youtube-nocookie.com', 'vimeo.com', 'wistia.com', 'loom.com']

function isValidVideoUrl(url: string): boolean {
  if (!url) return false
  try {
    const parsed = new URL(url)
    if (!['http:', 'https:'].includes(parsed.protocol)) return false
    return ALLOWED_VIDEO_DOMAINS.some((domain) => parsed.hostname.endsWith(domain))
  } catch {
    return false
  }
}

export function VideoEmbedPreview({ props: p }: Props) {
  const videoUrl = p.videoUrl as string
  const aspectRatio = (p.aspectRatio as string) || '16:9'
  const paddingTop = aspectRatio === '16:9' ? '56.25%' : aspectRatio === '4:3' ? '75%' : '56.25%'

  if (videoUrl && isValidVideoUrl(videoUrl)) {
    return (
      <div className="relative w-full" style={{ paddingTop }}>
        <iframe
          src={videoUrl}
          className="absolute inset-0 w-full h-full rounded"
          allow="autoplay; encrypted-media"
          allowFullScreen
          title="Video"
          sandbox="allow-scripts allow-same-origin allow-presentation"
        />
      </div>
    )
  }

  if (videoUrl && !isValidVideoUrl(videoUrl)) {
    return (
      <div className="relative w-full bg-tf-feedback-error-bg rounded flex items-center justify-center p-4" style={{ paddingTop }}>
        <div className="absolute inset-0 flex flex-col items-center justify-center gap-2">
          <AlertTriangle className="w-6 h-6 text-tf-feedback-error-text" />
          <p className="text-xs text-tf-feedback-error-text text-center">Invalid video URL. Allowed: YouTube, Vimeo, Wistia, Loom</p>
        </div>
      </div>
    )
  }

  return (
    <div
      className="relative w-full bg-tf-bg-hover rounded flex items-center justify-center"
      style={{ paddingTop }}
    >
      <div className="absolute inset-0 flex items-center justify-center">
        <div className="w-12 h-12 bg-tf-icon rounded-full flex items-center justify-center">
          <Play className="w-6 h-6 text-tf-text-inv ml-0.5" />
        </div>
      </div>
    </div>
  )
}
